// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Drawer_drawer__mhDuc","open":"Drawer_open__jm4TD","closeButton":"Drawer_closeButton__hyiLG","overlay":"Drawer_overlay__sVzC8","contents":"Drawer_contents__M_t_3"};